<div class="vertical">
  <div class="horizontal content">
    <ul>
      <li>
        <h3 class="text-bold text-uppercase">Invest</h3>
      </li>
      <li>About</li>
      <li>Contact Us</li>
      <li>Questions</li>
      <li>Help</li>
    </ul>

    <ul>
      <li>
        <h3 class="text-bold text-uppercase">Contacts</h3>
      </li>
      <li>
        <a href="https://fb.com/invest_sdv291" target="_blank">Facebook</a>
      </li>
      <li>
        <a href="https://instagram.com/invest_sdv291" target="_blank">Instagram: &#64;invest_sdv291</a>
      </li>
      <li>
        <a href="https://twitter.com/invest_sdv291" target="_blank">Twitter: &#64;invest_sdv291</a>
      </li>
      <li>
        <a href="https://t.me/invest_sdv291" target="_blank">Telegram: &#64;invest_sdv291</a>
      </li>
      <li>
        <a href="mailto:info@invest.sdv291.com" target="_blank">info&#64;invest.sdv291.com</a>
      </li>
    </ul>

    <ul>
      <li>
        <h3 class="text-bold text-uppercase">Language</h3>
      </li>
      <li *ngFor="let language of languageService.getLanguages()">
        <a (click)="switchLang(language)">{{languageService.displayLanguage(language)}}</a>
      </li>
    </ul>
  </div>

  <div class="bottom">
    <ul>
      <li>© {{now | date:'yyyy'}} {{'app.all.rights.reserved' | translate}}.</li>
      <li>
        <a routerLink="/copyright">Copyright</a>
      </li>
      <li>
        <a routerLink="/consent">Consent</a>
      </li>
      <li>
        <a routerLink="/privacy">Privacy Policy</a>
      </li>
      <li>
        <a routerLink="/disclaimer">Disclaimer</a>
      </li>
      <li>
        <a routerLink="/terms-and-conditions">Terms of Service</a>
      </li>
      <li>
        <a routerLink="/cookie">Cookie Policy</a>
      </li>
    </ul>
  </div>
</div>
